module.exports = __webpack_public_path__ + "static/img/horusSkyGod.745b264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/horusSkyGod.png
// module id = 69
// module chunks = 1